import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import Axios from "axios";

const routePrefix = "/verantwoordingvoortgangsrapport/";

const voortgangsrapportVerantwoordingApi = {
	get(vrId) {
		const serviceUrl = prependRoot(routePrefix + vrId, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	save(vrVerantwoording, documenten) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return Axios.post(serviceUrl, {
			item: vrVerantwoording,
			documenten
		}, {
				headers: {
					'accept': 'application/json'
				}
			});
	}
};

export default voortgangsrapportVerantwoordingApi;